import React, { useContext, useState } from 'react';
import { Button, Col, Input, Label, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from 'lodash';
import { ItemDropdownMenu, OrderDropdownMenu, Pager, SortHeader } from '.';
import { api, dateHelpers, helpers, reportHelpers, UserContext } from '../utils';

export default function InvoiceGrid(props) {
   const { currentUser } = useContext(UserContext);
   const [working, setWorking] = useState();

   function getExcel() {
      setWorking(true);
      props.exportXlsxCallback();
      setWorking(false);
   }

   function showTrackingInfo(invoiceNum) {
      api
         .fetch(`Reference/Track`, { invoiceNum: invoiceNum })
         .then(response => {
            if (response.data.success && response.data.url.length) {
               window.open(response.data.url);
            } else {
               toast.info("Only able to provide detailed tracking information for UPS Shipments")
            }
         })
         .catch(api.catchHandler);
   }

   let alreadyDisplayed = [];
   return (
      <>
         <Row className="align-items-center mt-3 mb-2">
            <Col className="transparent-background d-flex">
               {props.showAll ? null : (
                  <Pager
                     callBack={props.pagerCallback}
                     sizeCallback={props.sizeCallback ? props.sizeCallback : null}
                     pageNumber={props.pageNumber}
                     pageSize={props.pageSize ? props.pageSize : null}
                     totalPages={props.totalPages}
                     downloading={working}
                  />
               )}
               <Label className="my-0">
                  <Input
                     type="checkbox"
                     value={props.showAll}
                     checked={props.showAll}
                     onChange={(e) => props.onShowAll(e.target.checked)}
                     className="mx-3 float-start"
                  />
                  Show All?
               </Label>
            </Col>
            <Col className="transparent-background">
               {props.data && props.data.length && props.exportXlsxCallback
                  ? (<Button
                     title="Download as .xlsx"
                     className="shredButtonExcel float-end ms-2"
                     onClick={getExcel}
                     disabled={working}
                  >
                     <FontAwesomeIcon icon="file-excel" size="lg" />
                  </Button>)
                  : null
               }
               {props.data && props.data.length && props.exportPdfCallback
                  ? (<Button
                     title="Download as .pdf"
                     className="shredButton float-end"
                     onClick={props.exportPdfCallback}
                     disabled={working}
                  >
                     <FontAwesomeIcon icon="file-pdf" size="lg" />
                  </Button>)
                  : null
               }
            </Col>
         </Row>
         <Table size="sm" className="data-table">
            <thead className="table-header">
               <tr>
                  <th style={{ width: "3%" }}>
                     <SortHeader
                        displayName="Invoice"
                        field="orderId"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "orderId"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "3%" }}>
                     <SortHeader
                        displayName="Order"
                        field="originalOrderId"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "originalOrderId"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "4%" }}>
                     <SortHeader
                        displayName="PO"
                        field="customerPONumber"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "customerPONumber"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "4%" }}>
                     <SortHeader
                        displayName={<span>Ship<br />Date</span>}
                        field="documentDate"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "documentDate"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "5%" }}>
                     <SortHeader
                        displayName="Ship To"
                        field="stLabel"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "stLabel"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "5%" }}>
                     <SortHeader
                        displayName="Customer P/N"
                        field="customerItemNumber"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "customerItemNumber"}
                        callback={props.sortCallback}
                     />
                  </th>
                  {!currentUser?.isAnyCustomerTypeRole &&
                     <th style={{ width: "5%" }}>
                        <SortHeader
                           displayName="Item"
                           field="itemNumber"
                           sortDirection={props.sortDirection}
                           sorted={props.sortField === "itemNumber"}
                           callback={props.sortCallback}
                        />
                     </th>
                  }
                  <th style={{ width: "7%" }}>
                     Tracking #
                  </th>
                  <th style={{ width: "4%" }}>
                     <SortHeader
                        displayName={<span>Unit<br />Price</span>}
                        field="unitPrice"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "unitPrice"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "3%" }}>
                     Units
                  </th>
                  <th style={{ width: "3%" }}>
                     <SortHeader
                        displayName="Qty"
                        field="quantityLabel"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "quantityLabel"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "5%" }}>
                     <SortHeader
                        displayName={<span>Ext<br />Price</span>}
                        field="extendedPrice"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "extendedPrice"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "3%" }}>
                     <SortHeader
                        displayName="Balance"
                        field="invoiceBalance"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "invoiceBalance"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "5%" }}>
                     <SortHeader
                        displayName="Paid Date"
                        field="invoicePayOffDate"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "invoicePayOffDate"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "2%" }}>
                     <SortHeader
                        displayName="Days"
                        field="payDays"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "payDays"}
                        callback={props.sortCallback}
                     />
                  </th>
               </tr>
            </thead>
            <tbody>
               {_.map(props.data, (qr, ind) => {
                  const displayed = _.includes(alreadyDisplayed, qr.orderId);
                  alreadyDisplayed.push(qr.orderId);
                  return (
                     <tr key={ind} className={`tr-${ind % 2 === 0 ? "primary" : "secondary"}`}>
                        {displayed ? <td className='data-cell' /> :
                           <OrderDropdownMenu
                              invoiceNumber={qr.orderId}
                              orderId={qr.orderId}
                              attachmentKey={qr.originalOrderId ? qr.originalOrderId : qr.orderId}
                              attachmentCount={qr.soAttachmentCount}
                              orderType={qr.orderType}
                              hideCoALateShip
                           />}
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell" children={qr.originalOrderId} />}
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell" children={qr.customerPONumber} />}
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell" children={dateHelpers.toLongDateString(qr.documentDate)} />}
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell" children={qr.stLabel} />}
                        <td
                           className="data-cell"
                           onClick={() => reportHelpers.getCustomerSpecReport(qr.customerId, qr.itemNumber)}
                           title="Print Customer Spec Report"
                        >
                           <span className="shredLink fw-bold cursor-pointer">{qr.customerItemNumber}</span>
                        </td>
                        {!currentUser?.isAnyCustomerTypeRole &&
                           <ItemDropdownMenu
                              itemNumber={qr.itemNumber}
                              itemDescription={qr.itemWithDesc}
                              attachmentCount={qr.itemAttachmentCount}
                           />}
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell">
                              <span
                                 children={qr.trackingNumber}
                                 className="shredLink fw-bold cursor-pointer"
                                 onClick={() => showTrackingInfo(qr.orderId)}
                              />
                           </td>}
                        <td className="data-cell" children={helpers.formatCurrency(qr.unitPrice)} />
                        <td className="data-cell" children={qr.unitOfMeasure} />
                        <td className="data-cell" children={qr.qtytoinv.toLocaleString()} />
                        <td className="data-cell" children={helpers.formatCurrency(qr.extendedPrice)} />
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell" children={helpers.formatCurrency(qr.invoiceBalance)} />}
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell" children={dateHelpers.toLongDateString(qr.invoicePayOffDate) === '01/01/1900' ? "" : dateHelpers.toLongDateString(qr.invoicePayOffDate)} />}
                        {displayed ? <td className='data-cell' /> :
                           <td className="data-cell" children={qr.payDays === 0 ? "" : qr.payDays} />}
                     </tr>
                  )
               })}
            </tbody>
            <tfoot className="table-footer">
               <tr>
                  <td
                     className="fw-bold"
                     colSpan={!currentUser?.isAnyCustomerTypeRole ? "10" : "9"}
                     children="Totals Across All Pages:"
                  />
                  <td className="fw-bold" children={props.totals.quantityTotal.toLocaleString('en-US')} />
                  <td className="fw-bold" children={helpers.formatCurrency(props.totals.extendedPriceTotal)} />
                  <td className="fw-bold" children={helpers.formatCurrency(props.totals.balanceTotal)} />
                  <td />
                  <td className="fw-bold" children={props.totals.payDaysAverage} />
               </tr>
            </tfoot>
         </Table>
      </>
   )
}